import { Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { Sortable } from "lib/@components/Sortable"
import { RuleCard } from "./rule-card"
import { AddRuleButton } from "./add-rule-button"

export function RuleListEditor({ rules, onAdd, onUpdate, onRemove, onReorder, helperText }) {
    return (
        <Stack spacing={2}>
            <Typography variant="subtitle1" fontWeight={600}>
                Rules
            </Typography>
            <If value={helperText}>
                <Typography variant="body2" color="text.secondary">
                    {helperText}
                </Typography>
            </If>
            <Sortable items={rules} id="id" onOrdered={onReorder}>
                <Repeat list={rules} item={<RuleCard onUpdate={onUpdate} onRemove={onRemove} />} />
            </Sortable>
            <AddRuleButton onAdd={onAdd} />
        </Stack>
    )
}
